import { Button } from "@mui/material";
import { useOutletContext } from "react-router";
import ListPageHeader, { ListPageHeaderLeft, ListPageHeaderRight } from "../../Components/Misc/ListPageHeader";
import { SearchInput } from "../../Components/Misc/SearchExpand/search-expand";
import SearchIcon from "@mui/icons-material/Search";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AssetTable from "../../Components/Table/AssetsTable/assets-table";
import { useCallback, useEffect, useState } from "react";
import { assetService } from "../../Core/Api/services";
import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";
import TableSkeleton from "../../Components/Table/TableSkeleton";
import { useTranslation } from "react-i18next";
import { DriveAssetTable } from "../../Components/Drive/Common/drive-asset-table";
import DataTable from "../../Components/Table/table";
import { useDriveTableCols } from "../../Components/Drive/helpers/use-drive-table-cols";
import TableUuids from "../../Components/Table/table-uuids";
import { Stack } from "@mui/system";
import { useAppDispatch, useAppSelector } from "../../Redux/redux-store";
import { GetObjectResults, SetObjectResults } from "../../Redux/Reducers/redux-slice-drive";

function DriveTrash() {
  const { t } = useTranslation();
  // Outlet context used to pass props to parent DashboardLayout through react router dom
  const { selectedItemIds, setSelectedItems } = useOutletContext<{
    setSelectedItems: React.Dispatch<React.SetStateAction<number[]>>;
    selectedItemIds: number[];
  }>();

  const cols = useDriveTableCols();
  const dispatch = useAppDispatch();

  const objects = useAppSelector(GetObjectResults);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    assetService.GetTrash().then((response) => {
      if (response?.results) dispatch(SetObjectResults(response.results));

      setLoading(false);
    });
  }, []);

  const additionalActions = (
    <Button
      color="error"
      variant="contained"
      startIcon={<DeleteForeverIcon />}
      onClick={() => {
        assetService.ClearTrash(objects.map((x) => x.id));
      }}
    >
      {t("button:emptyTrash")}
    </Button>
  );

  return (
    <Stack sx={{ flex: "1 1 0", minHeight: 0 }} px={2}>
      {!loading && (
        <DataTable
          tableKey={TableUuids.DRIVE_TRASH}
          additionalActions={additionalActions}
          rows={objects?.filter((x) => filterText === "" || x.name?.includesAllWords(filterText))}
          columns={cols}
          // initialColumnVisibility={{ driveActions: false }}
          disableRowSelectionOnClick
        />
      )}
      {loading && <TableSkeleton />}
    </Stack>
  );
}

export default DriveTrash;
